import general from '@/assets/svg/seat/png/general.png';
import general_color_1 from '@/assets/svg/seat/png/general_color_1.png';
import general_color_2 from '@/assets/svg/seat/png/general_color_2.png';
import general_color_3 from '@/assets/svg/seat/png/general_color_3.png';
import general_color_4 from '@/assets/svg/seat/png/general_color_4.png';
import general_color_5 from '@/assets/svg/seat/png/general_color_5.png';
import general_color_6 from '@/assets/svg/seat/png/general_color_6.png';
import general_color_7 from '@/assets/svg/seat/png/general_color_7.png';
import general_color_8 from '@/assets/svg/seat/png/general_color_8.png';
import general_color_9 from '@/assets/svg/seat/png/general_color_9.png';
/**
 * @description 图片尺寸
 */
export const imgSizeList = [
  100, 120, 160, 220, 250, 310, 315, 320, 336, 360, 468, 490, 540, 560, 580, 600, 640, 720, 728, 760, 960, 970, 220, 30,
  40, 80, 200, 300, 400, 500, 600, 800, 1000,
];

/**
 * @description 座位等级图片
 */
export const deformedColorList = {
  0: general,
  1: general_color_1,
  2: general_color_2,
  3: general_color_3,
  4: general_color_4,
  5: general_color_5,
  6: general_color_6,
  7: general_color_7,
  8: general_color_8,
  9: general_color_9,
};
